import { useCallback } from 'react';
import { useCableSubscription } from './useCableSubscription';
import { useUpdateProjectCache } from 'hooks/projects/mutations.js'

/**
 * ProjectCable component for handling project-related cable events
 */
function ProjectCable({ projectId, onDisconnected, onConnected, onRejected }) {
  const updateProjectCache = useUpdateProjectCache();

  const handleProjectCable = useCallback((response) => {

    updateProjectCache.mutate({
      projectId: projectId,
      projectData: response
    });
  }, [updateProjectCache, projectId]);

  useCableSubscription({
    channel: { channel: 'ProjectsChannel', project: projectId },
    onReceived: handleProjectCable,
    onDisconnected,
    onConnected,
    onRejected
  });

  return null;
}

export default ProjectCable;
